import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Welcome from "@/components/Welcome";
import SignatureDishes from "@/components/SignatureDishes";
import StoryTeaser from "@/components/StoryTeaser";
import Experience from "@/components/Experience";
import Bakery from "@/components/Bakery";
import ReservationCTA from "@/components/ReservationCTA";
import Gallery from "@/components/Gallery";
import Catering from "@/components/Catering";
import OwnerNote from "@/components/OwnerNote";
import Instagram from "@/components/Instagram";
import Footer from "@/components/Footer";
import MenuPage from "@/pages/MenuPage";
import ReservationsPage from "@/pages/ReservationsPage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import StoryPage from "@/pages/StoryPage";
import AdminPage from "@/pages/AdminPage";
import WhatsAppButton from "@/components/WhatsAppButton";

const HomePage = () => (
  <main data-testid="home-page">
    <Hero />
    <Marquee />
    <Welcome />
    <SignatureDishes />
    <StoryTeaser />
    <Experience />
    <Bakery />
    <Catering />
    <ReservationCTA />
    <Gallery />
    <OwnerNote />
    <Instagram />
  </main>
);

function Layout() {
  const lenisRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href*="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      const [path, hash] = href.split("#");
      if (!hash) return;
      if (path && path !== window.location.pathname) return;
      let el = null;
      try {
        el = document.querySelector(`#${CSS.escape(hash)}`);
      } catch {
        return;
      }
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -64 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const t = setTimeout(() => lenisRef.current?.scrollTo(el, { offset: -64, immediate: true }), 300);
        return () => clearTimeout(t);
      }
    }
    lenisRef.current?.scrollTo(0, { immediate: true });
  }, [pathname]);

  return (
    <div className="bg-cream text-ink font-sans overflow-x-clip" data-testid="app-shell">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/reservations" element={<ReservationsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/story" element={<StoryPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <WhatsAppButton />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
